import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/Fractions/FractionsLevel.png";
import PracticeGame from "../../components/MP_PracticeGame";
import Calculator from "../../components/FractionsCalculator";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { MultiHook } from "tapable";

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

function GenerateRandom(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}

//Parameters are information about the number to be generated 
//[0] = min, 
//[1] = max, 
//[2] <=1 no set base, >1 = set base)
//[3]  <1 no max nominator, >= 1 is the max nominator
function GetFraction(param) {
    var bottom, top = 0;
    if (parseInt(param[2]) > 1)
        bottom = parseInt(param[2])
    else
        bottom = Math.floor(param[0] + Math.random() * (param[1] - param[0]));

    top = Math.floor(1 + Math.random() * ((bottom - 1) / 2));

    if (parseInt(param[3]) > 0 && top > parseInt(param[3]))
        top = param[3]

    var frac = [top, bottom];
    return frac;
}

function AddHTML(string) {
    console.log(string);
    if (string !== undefined) {
        var newText = string.toString().split(" ");
        for (var i = 0; i < newText.length; i++) {
            if (newText[i].includes('/')) {
                var tempString = newText[i].split("/");
                newText[i] = "<sup>" + tempString[0] + "</sup>&frasl;<sub>" + tempString[1] + "</sub>";
            }
        }
        return newText.join(" ");
    }
    else
        return "<b><u>ERROR empty string</b></u>"
}

var thisQuestion;
//Generates a question from a default question
function GenQuestion(q) {
    console.log(q);
    let generatedCalculation = [];
    var correctAnswer = "";
    var tempAnswer = "";
    var templateAnswer = "";
    var calc = parseInt(q.question_key.toString().replace("FracQ", ""));
    console.log("# = " + calc);
    if (calc <= 4) {
        var frac1, frac2;

        //Simple addition
        if (calc === 1) {
            //Create correct Answer
            frac1 = GetFraction([3, 9, 0, 0]);
            frac2 = GetFraction([3, 9, frac1[1], (frac1[1] - frac1[2] - 1)]);

            correctAnswer = (parseInt(frac1[0]) + parseInt(frac2[0])) + "/" + frac1[1];
            templateAnswer = "$/" + frac1[1];

            //Question text =
            generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " + " + frac2[0] + "/" + frac2[1];
        }
        //Simple subtraction
        if (calc === 2) {
            //Create correct Answer
            frac1 = GetFraction([3, 9, 0, 0]);
            frac2 = GetFraction([3, 9, frac1[1], (frac1[1] - frac1[2] - 1)]);

            correctAnswer = parseInt(frac1[0]) + "/" + frac1[1];
            templateAnswer = "$/" + frac1[1];

            //Question text =
            generatedCalculation[0] = (parseInt(frac1[0]) + parseInt(frac2[0])) + "/" + frac1[1] + " - " + frac2[0] + "/" + frac2[1];
        }
        //moderate addition
        if (calc === 3) {
            //Create correct Answer
            frac1 = GetFraction([2, 6, 0, 0]);
            frac2 = GetFraction([3, 9, parseInt(frac1[1]) * 2], (frac1[1] - frac1[2] - 1) * 2);

            correctAnswer = (parseInt(frac1[0]) * 2 + parseInt(frac2[0])) + "/" + frac2[1];
            templateAnswer = "$/" + frac2[1];

            //Question text =
            generatedCalculation[0] = (frac1[0]) + "/" + frac1[1] + " + " + frac2[0] + "/" + frac2[1];
        }
        //Moderate subtraction
        else if (calc === 4) {

            //Create the question
            frac1 = GetFraction([2, 6, 0, 0]);
            frac2 = GetFraction([3, 9, parseInt(frac1[1]) * 2], (frac1[1] - frac1[2] - 1) * 2);

            //Correct answer is the second fration generated
            correctAnswer = frac2[0] + "/" + frac2[1];
            templateAnswer = "$/" + frac2[1];

            //Question text =
            generatedCalculation[0] = (parseInt(frac1[0]) * 2 + parseInt(frac2[0])) + "/" + frac2[1] + " - " + frac1[0] + "/" + frac1[1];
        }
    }
    //Adding integers to fractions
    else if (calc == 5) {
        var frac1 = GetFraction([2, 9, 0, 0]);
        var number = Math.floor(2 + Math.random() * 7);

        //Question text =
        generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " + " + number;

        correctAnswer = number + " " + frac1[0] + "/" + frac1[1];
        templateAnswer = number + "  $/" + frac1[1];
    }
    //Subtracting fractions from integers
    else if (calc == 6) {
        var frac1 = GetFraction([2, 9, 0, 0]);
        var number = Math.floor(2 + Math.random() * 7);

        //Question text =
        generatedCalculation[0] = number + " - " + frac1[0] + "/" + frac1[1];

        correctAnswer = (parseInt(number) - 1) + " " + (parseInt(frac1[1]) - parseInt(frac1[0])) + "/" + frac1[1];
        templateAnswer = (parseInt(number) - 1) + " $/" + frac1[1];
    }
    //Equivient fractions
    else if (calc == 7) {
        var frac1 = GetFraction([2, 6, 0, 0]);
        var divider = Math.floor(2 + Math.random() * 3);
        var base = (parseInt(frac1[1]) * divider);
        //Question text =
        generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " is equivalent to: ?/" + base;

        correctAnswer = (parseInt(frac1[0]) * divider) + "/" + base;
        templateAnswer = "$/" + base;
    }
    //mult(easy)
    if (calc === 8) {
        //Create correct Answer
        frac1 = GetFraction([2, 5, 0, 0]);
        frac2 = GetFraction([2, 5, 0, 0]);

        //Question text =
        generatedCalculation[0] = "1/" + frac1[1] + " x " + "1/" + frac2[1];

        correctAnswer = "1/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
        templateAnswer = "1/$";
    }
    //mult(medium)
    if (calc === 9) {
        //Create correct Answer
        frac1 = GetFraction([2, 5, 0, 0]);
        frac2 = GetFraction([4, 7, 0, 0]);
        frac2[0] = Math.floor(1 + Math.random() * (frac2[1] - 1));

        //Question text =
        generatedCalculation[0] = "1/" + frac1[1] + " x " + frac2[0] + "/" + frac2[1];

        correctAnswer = frac2[0] + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
        templateAnswer = frac2[0] + "/$";
    }
    //mult(hard)
    if (calc === 10) {
        //Create correct Answer
        frac1 = GetFraction([4, 7, 0, 0]);
        frac2 = GetFraction([4, 7, 0, 0]);

        //Question text =
        generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " x " + frac2[0] + "/" + frac2[1];

        correctAnswer = (parseInt(frac1[0]) * parseInt(frac2[0])) + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
        templateAnswer = "$/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
    }
    //Division questions
    if (calc === 11) {
        //generate question
        frac1 = GetFraction([2, 6, 0, 0]);
        frac2 = GetFraction([2, 6, 0, 0]);

        //Question text =
        generatedCalculation[0] = 1 + "/" + frac1[1] + " ÷ " + 1 + "/" + frac2[1];

        correctAnswer = frac2[1] + "/" + frac1[1];
        templateAnswer = frac2[1] + "/$";
    }
    //Division questions
    if (calc === 12) {
        //generate question
        frac1 = GetFraction([2, 6, 0, 1]);
        frac2 = GetFraction([2, 6, 0, 0]);

        //Question text =
        generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " ÷ " + frac2[0] + "/" + frac2[1];

        correctAnswer = (frac2[1] * frac1[0]) + "/" + (frac1[1] * frac2[0]);
        templateAnswer = "$/" + (frac1[1] * frac2[0]);
    }
    //Division questions
    if (calc === 13) {
        //generate question
        frac1 = GetFraction([2, 6, 0, 1]);
        frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));
        frac2 = GetFraction([3, 6, 0, 0]);
        frac2[0] = Math.floor(2 + Math.random() * (frac2[1] - 2));

        //Question text =
        generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " ÷ " + frac2[0] + "/" + frac2[1];

        correctAnswer = (frac2[1] * frac1[0]) + "/" + (frac1[1] * frac2[0]);
        templateAnswer = "$/" + (frac1[1] * frac2[0]);
    }
    //Multiply an intiger by a fraction
    if (calc === 14) {
        var frac1 = GetFraction([2, 9, 0, 0]);
        var number = Math.floor(2 + Math.random() * 7);

        //Question text =
        generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " x " + number;

        correctAnswer = (number * frac1[0]) + "/" + frac1[1];
        templateAnswer = "$/" + frac1[1];
    }
    //Divide a integer by a fraction
    if (calc === 15) {
        var frac1 = GetFraction([2, 6, 0, 0]);
        var number = Math.floor(2 + Math.random() * 4);

        //Question text =
        generatedCalculation[0] = number + " ÷ " + frac1[0] + "/" + frac1[1];

        correctAnswer = (number * frac1[1]) + "/" + frac1[0];
        templateAnswer = "$/" + frac1[1];
    }
    //Decimals to fractions
    if (calc === 16) {
        var frac1 = GetFraction([2, 6, 0, 0]);
        frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));

        //Question text =
        generatedCalculation[0] = "Convert the following fraction to a decimal number: " + frac1[0] + "/" + frac1[1];

        correctAnswer = parseInt(frac1[0]) / parseInt(frac1[1]);
        correctAnswer = correctAnswer.toString().substr(0, 4);
        templateAnswer = "0.$";
    }
    //Fractions to percentages
    if (calc === 17) {
        var frac1 = GetFraction([2, 6, 0, 0]);
        frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));

        //Question text =
        generatedCalculation[0] = "Convert the following fraction to a percentage: " + frac1[0] + "/" + frac1[1];

        correctAnswer = parseInt(frac1[0]) / parseInt(frac1[1]);
        correctAnswer = (parseFloat(correctAnswer.toString().substr(0, 4)) * 100.0) + "%";
        templateAnswer = "$%";
    }
    //Decimals to fractions
    if (calc === 18) {
        var frac1 = GetFraction([2, 6, 0, 1]);

        var temp = parseInt(frac1[0]) / parseInt(frac1[1]);
        temp = temp.toString().substr(0, 4);

        //Question text =
        generatedCalculation[0] = "Convert the following decimal to a fraction: " + temp;

        correctAnswer = frac1[0] + "/" + frac1[1];
        templateAnswer = frac1[0] + "/$";
    }
    //Decimals to percentages
    if (calc === 19) {
        var num = (0.1 + Math.random() * 0.9).toString().substr(0, 4);
        generatedCalculation[0] = "Convert the following decimal to a percentage: " + num;
        correctAnswer = Math.round(parseFloat(num) * 100) + "%";
        templateAnswer = "$%";
    }
    //Percentages to fractions
    if (calc === 20) {
        var frac1 = GetFraction([2, 6, 0, 1]);

        var temp = parseInt(frac1[0]) / parseInt(frac1[1]);
        temp = Math.round(parseFloat(temp.toString().substr(0, 4)) * 100) + "%";

        //Question text =
        generatedCalculation[0] = "Convert the following decimal to a fraction: " + temp;

        correctAnswer = frac1[0] + "/" + frac1[1];
        templateAnswer = frac1[0] + "/$";
    }
    //Percentages to deciamals
    if (calc === 21) {
        var num = (0.1 + Math.random() * 0.9).toString().substr(0, 4);
        generatedCalculation[0] = "Convert the following percentage to a decimal: " + Math.round(parseFloat(num) * 100) + "%";
        correctAnswer = num;
        templateAnswer = "0.$";
    }
    //Rounding decimals to 1dp
    if (calc === 22) {
        var wholeNum = GenerateRandom(1, 8);
        var dec1Number = Math.round(GenerateRandom(10, 80) / 10) * 10;
        var dec2Number = GenerateRandom(1, 9);
        var num = parseFloat((wholeNum + (dec1Number / 100) + (dec2Number / 100)).toFixed(2));
        generatedCalculation[0] = "Round the following number to 1 decimal place: " + num;

        correctAnswer = Math.round(num * 10) / 10;
        templateAnswer = Math.floor(correctAnswer) + ".$";
    }
    //Rounding decimals to 2dp
    if (calc === 23) {
        var wholeNum = GenerateRandom(1, 8);
        var dec1Number = Math.round(GenerateRandom(10, 80) / 10) * 10;
        var dec2Number = GenerateRandom(1, 8);
        var dec3Number = GenerateRandom(1, 9);
        var num = parseFloat((wholeNum + (dec1Number / 100) + (dec2Number / 100) + (dec3Number / 1000)).toFixed(3));
        generatedCalculation[0] = "Round the following number to 2 decimal places: " + num;

        correctAnswer = Math.round(num * 100) / 100;
        templateAnswer = Math.floor(correctAnswer) + ".$";
    }
    //Adding decimals
    if (calc === 24) {
        var dec1 = (0.11 + Math.random() * 0.34).toString().substr(0, 4);
        var dec2 = (0.11 + Math.random() * 0.34).toString().substr(0, 4);
        var answer = parseFloat(dec1) + parseFloat(dec2);
        answer = Math.round(answer * 100) / 100;
        generatedCalculation[0] = dec1 + " + " + dec2 + " = ";
        correctAnswer = answer;
        templateAnswer = "0.$";
    }
    //Subracting decimals
    if (calc === 25) {
        var dec1 = (0.61 + Math.random() * 0.34).toString().substr(0, 4);
        var dec2 = (0.11 + Math.random() * 0.3).toString().substr(0, 4);
        var answer = parseFloat(dec1) - parseFloat(dec2);
        answer = Math.round(answer * 100) / 100;
        generatedCalculation[0] = dec1 + " - " + dec2 + " = ";
        correctAnswer = answer;
        templateAnswer = "0.$";
    }
    //Multiplying decimals
    if (calc === 26) {
        let options = [0.2, 0.25, 0.4, 0.5, 0.75];
        var dec1 = options[Math.floor(Math.random() * options.length)];
        var dec2 = (0.4 + Math.random() * 0.3).toString().substr(0, 3);
        var answer = parseFloat(dec1) * parseFloat(dec2);
        answer = Math.round(answer * 100) / 100;
        generatedCalculation[0] = dec1 + " x " + dec2 + " = ";
        correctAnswer = answer;
        templateAnswer = "0.$";
    }
    //Dividing integers by decimals
    if (calc === 27) {
        let options = [0.25, 0.5, 0.2];
        var dec1 = options[Math.floor(Math.random() * options.length)];
        var dec2 = Math.round(1 + Math.random() * 5);
        var answer = parseInt(dec2) / parseFloat(dec1);
        answer = Math.round(answer * 100) / 100;
        generatedCalculation[0] = dec2 + " ÷ " + dec1 + " = ";
        correctAnswer = answer;
        templateAnswer = "$";
    }
    if (calc == 28) {//percentage of a number
        var perc = GenerateRandom(1, 99);
        var number = GenerateRandom(1, 9) * 100;
        var answer = (number / 100) * perc;
        generatedCalculation[0] = "What is " + perc + "% of " + number + " ?";
        correctAnswer = answer;
        templateAnswer = "$";

    }

    if (calc == 29) {//adding mixed numbers
        //Create correct Answer
        //var frac1 = GetFraction([2, 4, 0, 0]);
        //console.log(frac1);
        //var frac2 = GetFraction([frac1[1]*2, frac1[1]*2, 0, 0]);

        //generate fractions
        var num1 = GenerateRandom(1, 9);
        var f1bottom = GenerateRandom(2, 5);
        var f2bottom = f1bottom * 2;
        var f1top = GenerateRandom(1, f1bottom);
        var f2top = GenerateRandom(2, f2bottom);
        var ans;
        var ansInt = num1;

        //calc answer
        if (((f1top * 2) + f2top) == f2bottom) {
            console.log("you right");
            console.log(f2top);
            f2top = f2top - 1;
            console.log(f2top);
            ans = (f1top * 2) + f2top;
        }
        else if (((f1top * 2) + f2top) > f2bottom) {
            ansInt = ansInt + 1;
            ans = ((f1top * 2) + f2top) - f2bottom;
        }
        else {
            ans = (f1top * 2) + f2top;
        }
        console.log(ans);

        //Question text =
        //generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " x " + frac2[0] + "/" + frac2[1];
        generatedCalculation[0] = num1 + " " + f1top + "/" + f1bottom + " + " + f2top + "/" + f2bottom;
        //correctAnswer = (parseInt(frac1[0]) * parseInt(frac2[0])) + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
        //templateAnswer = "$/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
        //templateAnswer =  "$"+ansInt.toString()+ f1top.toString()+ f1bottom.toString()+ ""+ f2top.toString()+ f2bottom.toString() + "+";
        correctAnswer = ansInt + " " + ans + "/" + f2bottom;;
        templateAnswer = ansInt + " " + "$/" + f2bottom;
    }

    if (calc == 30) {//subtracting mixed numbers

        //generate fractions
        var num1 = GenerateRandom(1, 9);
        var f1bottom = GenerateRandom(2, 5);
        var f2bottom = f1bottom * 2;
        var f1top = GenerateRandom(1, f1bottom);
        var f2top = GenerateRandom(1, f2bottom);
        var ans;
        var ansInt = num1;

        //calc answer
        if (((f1top * 2) - f2top) == 0) {
            f2top = f2top - 1;
            ans = (f1top * 2) - f2top;
        }
        else if (((f1top * 2) - f2top) < 0) {
            ansInt = ansInt - 1;
            ans = f2bottom - (f2top - (f1top * 2));
        }
        else {
            ans = (f1top * 2) - f2top;
        }
        console.log(ans);

        generatedCalculation[0] = num1 + " " + f1top + "/" + f1bottom + " - " + f2top + "/" + f2bottom;
        correctAnswer = ansInt + " " + ans + "/" + f2bottom;;
        templateAnswer = ansInt + " " + "$/" + f2bottom;
    }

    console.log(generatedCalculation)
    console.log(generatedCalculation[0]);
    console.log(correctAnswer);
    console.log(templateAnswer);
    generatedCalculation[0] = AddHTML(generatedCalculation[0]);
    generatedCalculation[1] = AddHTML(correctAnswer)
    generatedCalculation[2] = AddHTML(templateAnswer);

    //Creates object to return
    let questionObj = {
        question: generatedCalculation[0],
        answers: generatedCalculation[1],
        correct: correctAnswer,
        topic_id: q.topic_id
    };
    thisQuestion = questionObj;
    return generatedCalculation;
}

//var currQuestion;

export default function Multiplayer({ ...props }) {
    console.log("addition");
    const game = props.game;
    console.log(props);
    const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
    const [correctQuestions, setCorrectQuestions] = useState([]);
    const [incorrectQuestions, setIncorrectQuestions] = useState([]);
    const [currQuestion, setCurrentQuestion] = useState([,]);
    const [score, setScore] = useState(0);
    const [combo, setCombo] = useState(0);
    const [maxCombo, setMaxCombo] = useState(0);
    const [feedback, setFeedback] = useState([]);
    //const [realQuestions, setRealQuestions] = useState();
    const [workAround, setWorkAround] = useState(false);
    const [place, setPlace] = useState(0);




    //Called on click
    async function checkResult(value, callback) {
        var isCorrect = true;
        if (value) {
            //correct answer
            if (currQuestion[1] === value) {
                setCorrectQuestions([...correctQuestions, thisQuestion]);
                let multiplier = combo > 0 ? combo + 1 : 1;
                multiplier = multiplier > 5 ? 5 : multiplier;
                setScore(score + multiplier * 10);
                props.SubmitScore(multiplier * 10);

                if (combo < 99) {
                    setCombo(combo + 1);
                }
                if (combo > maxCombo) {
                    setMaxCombo(combo);
                }
            }
            //incorrect answer
            else {
                isCorrect = false;
                setIncorrectQuestions([...incorrectQuestions, thisQuestion]);
                if (combo === 0 && score >= 10) {
                    setScore(score - 10);
                    props.SubmitScore(-10);
                } else {
                    setCombo(0);
                }

                let result = {
                    question: currQuestion[0],
                    correct: currQuestion[1],
                    incorrect: value
                };
                setFeedback([...feedback, result]);
            }

            console.log(isCorrect);
            if (callback) {
                await callback(isCorrect, currQuestion[1]).then(() => {
                    console.log("Waited then gen");
                    setCurrentQuestion(newQuestion());
                    console.log(currQuestion[1].toString());
                });
            } else {
                console.log("Just gen");
                setCurrentQuestion(newQuestion());
                console.log(currQuestion[1].toString());
            }
        }
    }

    function GetListOfPositions() {
        //order the scores
        //console.log(props);
        //var web = props.parent.getwebrtc();
        var web = props.ReturnScores();
        var webcopy = JSON.parse(JSON.stringify(web));
        // console.log(webcopy);
        //then order the scores in descending order
        //display them as a list
        webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
        //console.log(webcopy);
        //replace yourname with YOU
        for (let i = 0; i < webcopy.length; i++) {
            if (webcopy[i].username == props.details.username)
                webcopy[i].username = "You"
        }
        var scoreText = [];
        for (let i = 0; i < webcopy.length; i++) {
            let temptext = webcopy[i].username + ": " + webcopy[i].score
            scoreText.push(temptext);
        }
        // console.log(scoreText);
        const listItems = scoreText.map((i) =>
            <li>{i}</li>
        );

        return listItems;
    }

    //Sets the question to a new one, currently no check for being the same question
    function newQuestion() {
        var difficulty = Math.floor(Math.random() * questions.length);
        var questionNum = Math.floor(Math.random() * questions[difficulty].length)
        var q = GenQuestion(questions[difficulty][questionNum]);;
        console.log(questions[difficulty][questionNum])
        console.log(q);
        setCurrentQuestion(q);
        return q;
    }

    function GetPlace() {
        var position = 0;
        //order the scores
        var web = props.ReturnScores();
        var webcopy = JSON.parse(JSON.stringify(web));
        //then order the scores in descending order
        //display them as a list
        webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
        console.log(webcopy);
        //gets your position in the list
        for (let i = 0; i < webcopy.length; i++) {
            if (webcopy[i].username == props.details.username) {
                setPlace(i + 1);
                position = i + 1;
            }

        }
        console.log(place);
        console.log(position);
        return position;
    }

    //Set the first question, called until questions are defined
    useEffect(() => {
        if (questions !== undefined) {
            var sample = newQuestion();
            setCurrentQuestion(sample);
            console.log(sample[1]);
        }
    }, [questions]);

    function ComboImage() {
        console.log(props);
        let comboNum = combo;
        if (combo > 4)
            comboNum = 4;
        var imageName = props.game.animation_path + "/combo" + comboNum + ".gif";
        //return <img src= {{imageName}} style={{position:"relative"}}></img>
        if (combo < 4) {
            return <img style={{ position: "relative", top: "-600px", right: "-1450px" }} src={require("../../assets/" + imageName)}></img>
        } else {
            return <img style={{ position: "relative", top: "-600px", right: "-1450px" }} src={require("../../assets/" + imageName)}></img>
        }
    }


    return (
        <PracticeGame
            parent={props}
            loading={!questions}
            correct={correctQuestions}
            incorrect={incorrectQuestions}
            score={score}
            onBack={() => props.onBack()}
            defaultTimer={60}
            restart={() => {
                setCombo(0);
                setScore(0);
                setCorrectQuestions([]);
                setIncorrectQuestions([]);
            }}
            feedback={feedback}
            homework_id={props.homework_id}
            getplace={() => GetPlace()}
        >
            <div>
                <Body>
                    <FormContent style={{ right: "100px", position: "relative", top: "0px", width: "200px", height: "50%" }}>
                        <br></br>
                        {GetListOfPositions()}
                    </FormContent>
                    <div>{currQuestion !== undefined ? (

                        <Calculator
                            currentQuestion={currQuestion}
                            onSubmitted={checkResult}
                        />

                    ) : <h1>help</h1>}
                    </div>
                    <Combo>
                        <span style={{ fontSize: "50px" }}>{combo}</span>
                        <span style={{ fontSize: "20px" }}>COMBO</span>
                    </Combo>

                </Body>
                {ComboImage()}
            </div>

        </PracticeGame>
    );
}

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url(${background});
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 40px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;
  font-size: 2em;

  h1 {
    color: #673b8b;
    font-size: 4em;
    margin: 0.25em;
  }


`;
